// extracted by mini-css-extract-plugin
export default {"drawer":"CandidateSourceOptionsDrawer_drawer__gFcaw"};